import { bindActionCreators } from 'redux'
import { modalOpen } from '../../../common/actions'
import { logout } from '../../../account/actions'

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      modalOpenDispatch: modalOpen,
      logoutDispatch: logout
    },
    dispatch
  )

export default mapDispatchToProps
